import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import {
  isValid,
  REQUIRED,
  validate,
} from "../../utils/Validation";
import SelectField from "../../components/SelectField";
import { listCategoriesByDrinkId } from "../../api/Category";
import { ATTRIBUTE_TYPE_LABEL, ATTRIBUTE_TYPE_OPTIONS, ATTRIBUTE_TYPES } from "../../constants/Consts";
import ColorGradient from "../../components/ColorGradient";


export default function EditAttributes({ 
  selected, 
  onClose, 
  onSave,
  drinkOptions = [],
}) {
  const [attribute, setAttribute] = useState({
    nameBr: "",
    order: 0,
    category: null,
    type: null,
    hexStartColor: "#ffff00",
    hexMiddleColor: "#ba652f",
    hexEndColor: "#000000",
    textLimit: null,
  });
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [selectedDrinkId, setSelectedDrinkId] = useState("");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const load = async () => {
      const res = await listCategoriesByDrinkId(selectedDrinkId);
      setCategories(res.map(c => ({ label: c.nameBr, value: c })));
    }

    if(!!selectedDrinkId){
      load();
    } else{
      setCategories([]);
    }
  }, [selectedDrinkId]);

  useEffect(() => {
    setAttribute(selected);
    setShow(selected != null);
    setErrors({});
    setSubmitting(false);
    if(!selected){
      setSelectedDrinkId("");
    }
  }, [selected]);

  const clear = () => {
    setAttribute({
      nameBr: "",
      order: 0,
      category: "",
      type: "",
      hexStartColor: "#ffff00",
      hexMiddleColor: "#ba652f",
      hexEndColor: "#000000",
      textLimit: null,
    });
    setErrors({});
    setSubmitting(false);
    setSelectedDrinkId("");
  };

  const save = async () => {
    setSubmitting(true);
    const data = { ...attribute }
    const rules = {
      nameBr: REQUIRED,
      order: REQUIRED,
      category: REQUIRED,
      type: REQUIRED,
    };
    if(data.type === "COLOR"){
      rules.hexStartColor = REQUIRED;
      rules.hexMiddleColor = REQUIRED;
      rules.hexEndColor = REQUIRED;
    } else{
      data.hexStartColor = null;
      data.hexMiddleColor = null;
      data.hexEndColor = null;
    }
    const errors = await validate(rules, data);
    if (isValid(errors)) {
      onSave(data);
    } else {
      setErrors(errors);
    }
    setSubmitting(false);
  };

  return (
    <Modal
      visible={show}
      onClose={() => {
        clear();
        onClose();
      }}
      title={attribute?.id ? "Editar Atributo" : "Novo Atributo"}
      Action={<Button disabled={submitting} submitting={submitting} onClick={() => save()}>Cadastrar</Button>}
    >
      <TextField
        label="Nome (PT-BR)"
        className="mb-5"
        placeholder="Insira um nome"
        value={attribute}
        field="nameBr"
        update={setAttribute}
        errors={errors}
      />
      <TextField
        label="Posição"
        className="mb-5"
        placeholder="Insira a posição"
        value={attribute}
        field="order"
        update={(data) => {
          data.order = data.order.replace(new RegExp("[^0-9]", "g"), "");
          setAttribute(data);
        }}
        errors={errors}
      />
      { !!attribute?.id ? (
        <>
          <TextField
            label="Bebida"
            className="mb-5"
            value={attribute?.category?.drink?.nameBr ?? ""}
            disabled={true}
          />
          <TextField
            label="Categoria"
            className="mb-5"
            value={attribute?.category?.nameBr ?? ""}
            disabled={true}
          />
          <TextField
            label="Tipo"
            className="mb-5"
            value={!!attribute?.type ? ATTRIBUTE_TYPE_LABEL[attribute.type] : ""}
            disabled={true}
          />
        </>
      ) : (
        <>
          <SelectField
            label="Bebida"
            className="mb-5"
            value={selectedDrinkId} 
            options={drinkOptions} 
            update={(v) => setSelectedDrinkId(v)} 
          />
          <SelectField
            className="mb-5"
            label="Categoria"
            errors={errors}
            field="category"
            options={categories}
            update={setAttribute}
            value={attribute}
          />
          <SelectField
            className="mb-5"
            label="Tipo"
            errors={errors}
            field="type"
            options={ATTRIBUTE_TYPE_OPTIONS}
            update={setAttribute}
            value={attribute}
          />
        </>
      )}
      { attribute?.type === ATTRIBUTE_TYPES.COLOR ? (
        <>
          <TextField
            className="mb-5"
            placeholder="Insira a primeira cor (Ex: #ffff00)"
            value={attribute}
            field="hexStartColor"
            update={(data) => {
              data.hexStartColor = "#" + data.hexStartColor.replace(new RegExp("[^0-9a-fA-F]", "g"), "").toUpperCase().slice(0, 8);
              setAttribute(data);
            }}
            errors={errors}
          />
          <TextField
            className="mb-5"
            placeholder="Insira a segunda cor (Ex: #ba652f)"
            value={attribute}
            field="hexMiddleColor"
            update={(data) => {
              data.hexMiddleColor = "#" + data.hexMiddleColor.replace(new RegExp("[^0-9a-f]", "g"), "").slice(0, 8).toUpperCase();
              setAttribute(data);
            }}
            errors={errors}
          />
          <TextField
            className="mb-5"
            placeholder="Insira a terceira cor (Ex: #000000)"
            value={attribute}
            field="hexEndColor"
            update={(data) => {
              data.hexEndColor = "#" + data.hexEndColor.replace(new RegExp("[^0-9a-f]", "g"), "").slice(0, 8).toUpperCase();
              setAttribute(data);
            }}
            errors={errors}
          />
          <ColorGradient
            start={attribute?.hexStartColor}
            middle={attribute?.hexMiddleColor}
            end={attribute?.hexEndColor}
          />
        </>
      ) : attribute?.type === ATTRIBUTE_TYPES.TEXT &&(
        <TextField
          label="Quantidade máxima de caracteres (deixe vazio para não ter limite)"
          className="mb-5"
          placeholder="Limite de caracteres"
          value={attribute}
          field="textLimit"
          update={(data) => {
            data.textLimit = data.textLimit.replace(new RegExp("[^0-9]", "g"), "");
            setAttribute(data);
          }}
          errors={errors}
        />
      )}
      <div className="h-20" />
    </Modal>
  );
}
